export default __webpack_public_path__ + "static/media/ghibligibberi.5f19453f.gif";